import styles from './styles.module.scss';

export const Spinner = () => {
  return <div className={styles.spinner} />;
};
